import { filepath } from "../services/configs/server";


/** fix file urls */
export const formatUrl = (uri) => {
    let  str = `${filepath}/${uri}`;
    return str;
}

/** use this in production */
export const hidePdfProd = (uri) => {
    const trim = uri?.slice(1);
    let  str = `/ViewerJS/#../${filepath}/${trim}`;
    return str;
}

/** use this in development */
export const hidePdfDev = (uri) => {
    const trim = uri?.slice(1);
    let  str = `${filepath}/ViewerJS/#..${trim}`;
    console.log({uri});
    return str;
}

export const hidePdf = (uri) => window.location.origin === "http://localhost:3000" 
? hidePdfDev(uri): hidePdfProd(uri);